import axios from 'axios';

const getBaseApiUrl = () => {
  if (typeof window !== 'undefined' && window.WConfiguration?.API_URL) {
    return window.WConfiguration.API_URL;
  }

  return process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1';
};

/**
 * Creates and configures the base API client.
 * Shared across all domain services.
 */
const createApiClient = () => {
  const client = axios.create({
    baseURL: getBaseApiUrl(),
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 10000 // 10 seconds
  });

  // Request interceptor to add auth token
  client.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor for error handling
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      console.error('API Error:', error);
      return Promise.reject(error);
    }
  );

  return client;
};

// Export singleton instance
export const apiClient = createApiClient();
